import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-mail-02',
  imports: [],
  templateUrl: './mail-02.html',
  styleUrl: './mail-02.scss',
})
export class Mail02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
